/* @flow */
import CurrentUser from 'auth/CurrentUser';
import GroupStore from 'groups/stores/GroupStore';
import { PromptNames } from 'constants/PromptConstants';
import PromptStore from 'stores/PromptStore';
import DeviceStore from 'stores/DeviceStore';

function needsSchool() {
  return CurrentUser.getUser().getNeeds().organization;
}

function needsGroup() {
  const user = CurrentUser.getUser();

  return !PromptStore.hasDismissed(PromptNames.NUX_SETUP_CLASS)
      && user.needsGroups() // User object isn't updated when a group is created
      && (GroupStore.getOwnedGroups().length === 0);
}

function needsSignature() {
  const user = CurrentUser.getUser();
  return user.getSignInCount() < 3 && !PromptStore.hasDismissed(PromptNames.NUX_SETUP_SIGNATURE);
}

function needsSmsDevice() {
  const user = CurrentUser.getUser();

  return (
    user.getSignInCount() <= 2 &&
    user.hasSmsSupported() &&
    DeviceStore.getDevices().type('sms').length < 1 &&
    !PromptStore.hasDismissed(PromptNames.NUX_SETUP_SMS_DEVICE)
  );
}

function needsSubscription() {
  const user = CurrentUser.getUser();

  return (
    user.getSignInCount() <= 2 &&
    user.getNeeds().subscriptions &&
    !PromptStore.hasDismissed(PromptNames.NUX_SETUP_FIRST_SUBSCRIPTION)
  );
}

function needsFullName() {
  return CurrentUser.getUser().getNeeds().full_name;
}

function needsEmail() {
  return !CurrentUser.hasEmail();
}

function needsPassword() {
  return CurrentUser.getUser().getNeeds().password;
}

const steps = {
  teacher: [
    { eligible: needsPassword, transitionTo: '/setup/password' },
    { eligible: needsFullName, transitionTo: '/setup/name' },
    { eligible: needsSignature, transitionTo: '/setup/signature' },
    { eligible: needsEmail, transitionTo: '/setup/email' },
    { eligible: needsGroup, transitionTo: '/setup/class' },
    { eligible: needsSchool, transitionTo: '/setup/school' },
  ],
  student: [
    { eligible: needsPassword, transitionTo: '/setup/password' },
    { eligible: needsSmsDevice, transitionTo: '/setup/device/sms' },
    { eligible: needsSubscription, transitionTo: '/setup/subscriptions' },
    { eligible: needsFullName, transitionTo: '/setup/name' },
  ],
  parent: [
    { eligible: needsPassword, transitionTo: '/setup/password' },
    { eligible: needsFullName, transitionTo: '/setup/name' },
    { eligible: needsSmsDevice, transitionTo: '/setup/device/sms' },
    { eligible: needsSubscription, transitionTo: '/setup/subscriptions' },
  ],
};

export default {
  getNextEligibleStep: (role: string) => {
    const stepsForRole = steps[role];
    const eligibleStep = (stepsForRole || []).find(step => step.eligible());
    return eligibleStep && eligibleStep.transitionTo;
  },
};



// WEBPACK FOOTER //
// ./src/setup/utils/setupCriteria.js